import React from "react";
import { useTranslation } from "react-i18next";
import { PaymentUnitDetails } from "../../../services/FrontlineQ/frontlineQAPI.types";
import defaultContent from "../../../content/frontlineQ";
import LeafTable, {
  TableHeader,
  ALIGN,
  BACKGROUND_COLORS,
  TableRow,
  RowColumn,
  STYLES,
  HEADER_BACKGROUND_COLORS,
} from "../../../common/leaf/LeafTable/LeafTable";
import "./PaymentUnitDetails.scss";

type Props = {
  data: PaymentUnitDetails;
};

const PaymentUnitDetailsTile = ({ data }: Props) => {
  const { t } = useTranslation("frontlineQ");

  const headers: TableHeader[] = [
    {
      value: t("paymentDetails.pinLevelColumnLabels.pinLevel", {
        defaultValue: defaultContent.paymentDetails.pinLevelColumnLabels.pinLevel,
      }),
      columnAlign: ALIGN.LEFT,
    },
    ...data.PinLevelColumnHeaderContentKeys.map((key) => ({
      value: t(`paymentDetails.pinLevelColumnLabels.${key}`, {
        defaultValue: defaultContent.paymentDetails.pinLevelColumnLabels[key],
      }),
      columnAlign: ALIGN.CENTER,
    })),
  ];

  const hasLongHeader = headers.some((header) => `${header.value}`.length > 30);

  const getHighlightColor = (performanceLevel: string): BACKGROUND_COLORS => {
    const level = performanceLevel.toLowerCase();
    return level === "maintain" || level === "grow" ? BACKGROUND_COLORS.GREEN : BACKGROUND_COLORS.ORANGE;
  };

  const rows: TableRow[] = data.Rows.map((row): TableRow => {
    const highlightColor = getHighlightColor(row.FQPerformanceLevel);

    const cells: RowColumn[] = [
      {
        value: t(`paymentDetails.FQPerformanceRowLabels.${row.FQPerformanceLevel}`, {
          defaultValue: defaultContent.paymentDetails.FQPerformanceRowLabels[row.FQPerformanceLevel],
        }),
        columnAlign: ALIGN.LEFT,
        verticalHeaders: true,
        headerStyle: STYLES.DEFAULT,
      },
      ...row.Cells.map(
        (cell): RowColumn => ({
          value: (
            <span className={cell.Highlighted === true ? "cell-highlight" : "cell-normal"}>
              {cell.PaymentUnitAmount}
            </span>
          ),
          columnAlign: ALIGN.CENTER,
          backgroundColor: cell.Highlighted === true ? highlightColor : undefined,
        }),
      ),
    ];
    return { row: cells };
  });

  return (
    <div className={`payment-unit-details ${hasLongHeader ? "payment-unit-details__longHeader" : ""}`}>
      <div className="payment-unit-details__scroll-container">
        <LeafTable
          header={headers}
          rows={rows}
          headerStyle={STYLES.DEFAULT}
          headerBackgroundColor={HEADER_BACKGROUND_COLORS.BLACK}
          hasBorder
          hasStripedRows={false}
          hasRoundedCorners
          evenColumnSpacing={false}
          hasVerticalDividers
        />
      </div>
    </div>
  );
};

export default PaymentUnitDetailsTile;
